// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';

export const updateFailedModeDropDown = (key, collection) => ({
    collection,
    key,
    property: 'failureMode',
    type: actions.UPDATE_CLAIM_NORMAL_FAILED_MODE
});

export const updateDownTimeDropDown = (key, collection) => ({
    collection,
    key,
    property: 'downtime',
    type: actions.UPDATE_CLAIM_NORMAL_DOWN_TIME
});

export const updateNormalClaimFailedArea = value => ({
    property: 'failureArea',
    type: actions.UPDATE_CLAIM_NORMAL_FAILED_AREA,
    value
});

export const updateNormalClaimPartSerialNumber = value => ({
    property: 'failurePartSerialNumber',
    type: actions.UPDATE_CLAIM_NORMAL_PART_SERIAL_NUMBER,
    value
});

export const updateNormalClaimFailedModeComments = value => ({
    property: 'failureModeComments',
    type: actions.UPDATE_CLAIM_NORMAL_FAILED_MODE_COMMENTS,
    value
});

export const updateNormalClaimDtacCase = value => ({
    property: 'dtacCase',
    type: actions.UPDATE_CLAIM_NORMAL_DTAC_CASE,
    value
});

export const updateNormalClaimDtacSolution = value => ({
    property: 'dtacSolution',
    type: actions.UPDATE_CLAIM_NORMAL_DTAC_SOLUTION,
    value
});

export const updateNormalClaimOperatorsComplaint = value => ({
    property: 'operatorsComplaint',
    type: actions.UPDATE_CLAIM_NORMAL_OPERATORS_COMPLAINT,
    value
});

export const updateNormalClaimComplaintCause = value => ({
    property: 'causeOfComplaining',
    type: actions.UPDATE_CLAIM_NORMAL_COMPLAINT_CAUSE,
    value
});

export const updateNormalClaimComplaintCorrection = value => ({
    property: 'howWasComplaintCorrected',
    type: actions.UPDATE_CLAIM_NORMAL_COMPLAINT_CORRECTION,
    value
});

export const updateNormalClaimOperatorComments = value => ({
    property: 'comments',
    type: actions.UPDATE_CLAIM_NORMAL_OPERATORS_COMMENTS,
    value
});

export const updateNormalClaimBasisForSettlement = value => ({
    property: 'basisForSettlement',
    type: actions.UPDATE_CLAIM_NORMAL_BASIS_FOR_SETTLEMENT,
    value
});



// WEBPACK FOOTER //
// ./src/claim/normal/action-creators/failure-panel.js